import { Injectable } from '@angular/core';
import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

/**
 * Keeps ChatWrapperComponent alive when navigating between any chat/workstation routes.
 * This prevents the React MFE from being unmounted and remounted (which breaks it because
 * React's root becomes orphaned on the removed DOM element).
 * Context switches (chat libre ↔ workstation) are handled by the MFE's updateChatContext().
 */
@Injectable()
export class ChatReuseStrategy implements RouteReuseStrategy {
  private isChatRoute(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path ?? '';
    return path === 'admin/chat' || path.startsWith('admin/workstation');
  }

  shouldDetach(_route: ActivatedRouteSnapshot): boolean { return false; }
  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {}
  shouldAttach(_route: ActivatedRouteSnapshot): boolean { return false; }
  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null { return null; }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (this.isChatRoute(future) && this.isChatRoute(curr)) {
      return true;
    }
    return future.routeConfig === curr.routeConfig;
  }
}
